module.exports = __webpack_public_path__ + "img/slide-images.bba22920.jpg";